module.exports = __webpack_public_path__ + "assets/dc5a701092887804b2d92dfe6e93a591.png";